// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fO","catalogByServiceItem__title":"c-k_fP"};